<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <!-- User Management -->
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>User Management</h2>
          </div>
          <!-- User Management List -->
          <div class="body pt-0">
            <div class="chart-top-action d-md-flex justify-content-end py-3">
              <div class="fliter-main mr-auto mt-3 mt-md-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <!-- Add new user Buttons -->
              <div class="mt-2 mt-sm-0">
                <router-link
                  to="/user-managment/user-add"
                  class="btn btn-primary btn-lg btn-mw"
                >
                  Add User
                  <i class="fa fa-plus-square ml-1"></i>
                </router-link>
              </div>
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'role'"
                    >
                      <span class="float-label w-100">
                        <label for="transaction">Select Role</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="roles_options"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="
                        item.field &&
                        (item.field.id == 'name' || item.field.id == 'email')
                      "
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        :placeholder="
                          'Enter ' +
                          (item.field.id == 'name' ? 'Payangel Id' : 'Email')
                        "
                      />
                      <div class="line"></div>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel/Clear
                  </button>
                </div>
              </b-collapse>
            </div>
            <!-- displayed Filters -->
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <span class="badge badge-warning-solid">
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- Table -->
            <b-table
              responsive
              outlined
              table-class="mb-0 table-custom"
              head-variant="light"
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template #cell(role)="data">
                <p class="role-badge badge-group-table mb-0">
                  <span
                    class="badge ml-0 badge-info"
                    v-for="(roles, index) in data.value"
                    :key="index"
                  >
                    {{ roles }}
                  </span>
                </p>
              </template>
              <template #cell(permissions)="data">
                <p class="services-badge badge-group-table mb-0">
                  <span
                    class="badge ml-0 badge-default"
                    v-for="(services, index) in data.value"
                    :key="index"
                  >
                    {{ services }}
                  </span>
                </p>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="edit()">Edit</b-dropdown-item>
                  <b-dropdown-item @click="showAlert">Delete</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 d-flex align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/plugins/sweetalert2";
export default {
  name: "UserListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    Multiselect: () => import("vue-multiselect"),
  },
  data() {
    return {
      isVisibleFilter: false,
      items: [
        {
          name: "Brain O'Conner",
          email: "connerBrain@mailinator.com",
          role: ["ADMIN"],
          permissions: ["DASHBOARD"],
          action: "",
        },
        {
          name: "Ben Murphy",
          email: "benPM99@gmail.com",
          role: ["MANAGER"],
          permissions: ["DASHBOARD", "USER MANAGEMENT"],
          action: "",
        },
        {
          name: "John Smith",
          email: "john@hotmail.com",
          role: ["OWNER"],
          permissions: [
            "DASHBOARD",
            "USER MANAGEMENT",
            "TRANSACTIONS",
            "LISTING",
          ],
          action: "",
        },
        {
          name: "Emma Thomas",
          email: "emthomas@mail.com",
          role: ["USER"],
          permissions: ["DASHBOARD"],
          action: "",
        },
        {
          name: "Adam Driver",
          email: "AdamD@yopmail.com",
          role: ["MANAGER"],
          permissions: ["DASHBOARD", "USER MANAGEMENT", "LISTING"],
          action: "",
        },
        {
          name: "Hal Chalamet",
          email: "halC12@gmail.com",
          role: ["USER"],
          permissions: ["DASHBOARD"],
          action: "",
        },
      ],

      fields: [
        { key: "name", label: "Name", sortable: true, thClass: "th_sortfix" },
        { key: "email", label: "Email", sortable: true, thClass: "th_sortfix" },
        {
          key: "role",
          label: "Role",
          sortable: true,
          thClass: "role-badge th_sortfix",
        },
        {
          key: "permissions",
          label: "Permissions",
          sortable: true,
          thClass: "services-badge th_sortfix",
        },
        { key: "action", label: "Action", thClass: "access-badge th_sortfix" },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      filterField: [
        { id: "name", name: "Name", $isDisabled: false },
        { id: "email", name: "Email", $isDisabled: false },
        { id: "role", name: "Role", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: { id: "name", name: "Name", $isDisabled: false },
          search: "",
        },
      ],
      roles_options: ["Owner", "Admin", "Manager", "User"],
      displayFilters: [],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    edit() {
      this.$router.push({ path: "/user-managment/user-edit" });
    },
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success",
            );
          }
        });
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = e.target.value;
        }
      }
    },
    // for openFilters
    openFilters() {
      if (this.advanceFilters == 0) {
        this.advanceFilters = [
          {
            field: { id: "name", name: "Name", $isDisabled: false },
            search: "",
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    // apply filter
    applyTestfilter() {
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
          filter_value: item.search,
        };
        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("user-list-filter", params);
      this.displayFilters = this.$cookies.get("user-list-filter");
      console.log("params", params);
    },
    // clear filter
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "name", name: "Name", $isDisabled: false },
          search: "",
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      this.$cookies.set("user-list-filter", this.displayFilters);
    },
    // append filters
    appendFilter() {
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
        });
        this.filterField.filter(
          (data) => data.$isDisabled == false,
        )[0].$isDisabled = true;
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        this.filterField.filter(
          (data) => data.id == item.field.id,
        )[0].$isDisabled = true;
      });
    },
    // to remove filters
    removeFilter(index) {
      this.filterField.filter(
        (data) => data.id == this.advanceFilters[index].field.id,
      )[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      this.$cookies.set("user-list-filter", this.displayFilters);
    },
    cookieFilters() {
      this.displayFilters =
        this.$cookies.get("user-list-filter") != null
          ? this.$cookies.get("user-list-filter")
          : [];
      let filters = [];
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          this.filterField.filter(
            (data) => data.id == item.filter_field,
          )[0].$isDisabled = true;
          if (item.filter_field == "role") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: this.roles_options.filter(
                (data) => data == item.filter_value,
              )[0],
            });
          }
          if (item.filter_field == "name" || item.filter_field == "email") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: item.filter_value,
            });
          }
        });
        this.advanceFilters = filters;
      }
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    setTimeout(() => {
      this.cookieFilters();
    }, 100);
  },
};
</script>
